import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ThemeProvider from "./helpers/components/ThemeProvider";
import { initGA, trackPageview } from "./analytics";
import ScrollToTopButton from "./helpers/components/ScrollToTopButton";
import { Analytics } from "@vercel/analytics/react";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);
  return (
    <ThemeProvider>
      <Navbar />
      <Outlet />
      <Analytics />
      <ScrollToTopButton />
      <Footer />
    </ThemeProvider>
  );
};

export default App;
